// @flow

export const RECEIVED_PRODUCT_TYPE_SETTINGS: 'listo/productTypeSettings/RECEIVED_PRODUCT_TYPE_SETTINGS' = 'listo/productTypeSettings/RECEIVED_PRODUCT_TYPE_SETTINGS';

export const DISPLAY_MONTHLY = 'monthly';
export const DISPLAY_YEARLY = 'yearly';

export default null;
